import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';

import { useEffect, useRef, useState } from 'react';
import {
  removeConversationFromList,
  setActiveConversation,
  setConversationAttributes,
  updateConversationAttributesLocaly
} from '../../../redux/slices/communication';

import { useClickAway } from 'react-use';
import { PRIORITIES } from '../constants';

export function InfoCard() {
  const { t } = useTranslate();
  const {
    data: { activeConversation }
  } = useSelector((state) => state.communication);

  const status = [
    { name: 'open', class: 'fa-duotone fa-inbox' },
    { name: 'closed', class: 'fa-duotone text-success fa-circle-check' }
  ];
  const [currentPriority, setCurrentPriority] = useState(
    activeConversation?.priority
  );
  const [currentStatus, setCurrentStatus] = useState(
    activeConversation?.status
  );
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showPriorityDropdown, setShowPriorityDropdown] = useState(false);
  const prioprityRef = useRef(null);
  useClickAway(prioprityRef, () => {
    setShowPriorityDropdown(false);
  });

  const statusRef = useRef(null);
  useClickAway(statusRef, () => {
    setShowStatusDropdown(false);
  });
  useEffect(() => {
    console.log('on change setting those values');
    setCurrentPriority(activeConversation?.priority);
    setCurrentStatus(activeConversation?.status);
  }, [activeConversation]);
  const dispatch = useDispatch();
  return (
    <div className="card m-2 p-4 shadow row w-100">
      <b className="fs-6  text-muted m-0 p-0">{t('info')}</b>
      <table border="0" className="w-100 mx-2 my-2">
        <tbody className={'w-100'}>
          <tr className={'w-100'}>
            <td className="py-1  text-nowrap" style={{ width: '1%' }}>
              <b className="text-muted">
                {t('communication.general_info.prioprity')}
              </b>
            </td>

            <td className="fw-bold">
              <Dropdown
                ref={prioprityRef}
                className={'w-100 text-start'}
                show={showPriorityDropdown}
                onClick={() => {
                  setShowPriorityDropdown(!showPriorityDropdown);
                }}
              >
                <Dropdown.Toggle size="sm" variant="none">
                  <i
                    className="fa-solid fa-circle"
                    style={{
                      color: PRIORITIES?.[currentPriority]?.color
                    }}
                  ></i>
                  <span className="px-2">
                    {t(PRIORITIES?.[currentPriority]?.name)}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {PRIORITIES?.map((item, index) => (
                    <Dropdown.Item
                      onClick={() => {
                        setCurrentPriority(index);
                        dispatch(
                          setConversationAttributes(activeConversation.uuid, {
                            priority: index
                          })
                        );
                        dispatch(
                          updateConversationAttributesLocaly(
                            activeConversation.uuid,
                            {
                              priority: index
                            }
                          )
                        );
                      }}
                      key={index}
                      value={Number(index)}
                      active={index === currentPriority}
                    >
                      <i
                        className="fa-solid fa-circle"
                        style={{
                          color: item.color
                        }}
                      ></i>
                      <span className="px-2">{t(item?.name)}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
          <tr className={'w-100'}>
            <td className="py-1 text-nowrap" style={{ width: '1%' }}>
              <b className="text-muted">
                {t('communication.general_info.status')}
              </b>
            </td>

            <td className="fw-bold">
              <Dropdown
                ref={statusRef}
                className={'w-100 text-start'}
                show={showStatusDropdown}
                onClick={() => {
                  setShowStatusDropdown(!showStatusDropdown);
                }}
              >
                <Dropdown.Toggle
                  size="sm"
                  variant="none"
                  className={'w-100 text-start'}
                >
                  <i className={status?.[currentStatus]?.class}></i>
                  <span className="px-2">
                    {t(status?.[currentStatus]?.name)}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {status?.map((item, index) => (
                    <Dropdown.Item
                      onClick={() => {
                        setCurrentStatus(index);
                        dispatch(
                          setConversationAttributes(activeConversation.uuid, {
                            status: index
                          })
                        );
                        dispatch(
                          updateConversationAttributesLocaly(
                            activeConversation.uuid,
                            { status: index }
                          )
                        );

                        if (index === 1) {
                          dispatch(setActiveConversation(null));

                          // remove from conversation list

                          dispatch(
                            removeConversationFromList(activeConversation.uuid)
                          );
                        }
                      }}
                      key={index}
                      value={Number(index)}
                      active={index === currentStatus}
                    >
                      <i className={`${item.class}`}></i>
                      <span className="px-2">{t(item?.name)}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
